import axios from "../../axios";
const urlTaxonomies = "/taxonomies";

const state = {
  list: [],
  allTaxonomies: [],
  menuFIlterLibraryDictionary: [],
  menuFIlterBlock: [],
};

const actions = {
  async getMenuFIlterLibraryDictionary({ commit }, payload) {
    const response = await axios.get("/taxonomies/library-dictionary", {
      params: payload,
    });
    if (response.status === 200) {
      commit("SET_MENU_FILTER_LIBRARYDICTIONARY", response.data.data);
    }
    return response;
  },

  async getMenuFIlterBlock({ commit }, payload) {
    const response = await axios.get("/taxonomies/menu-filter-block", {
      params: payload,
    });
    if (response.status === 200) {
      commit("SET_MENU_FILTER_BLOCK", response.data.data);
    }
    return response;
  },

  async getList({ commit }, payload) {
    const response = await axios.get(urlTaxonomies, { params: payload });
    if (response.status === 200) {
      commit("SET_TAXONOMIES", response.data.data);
    }
    return response;
  },

  async getAll({ commit }, payload) {
    const response = await axios.get(urlTaxonomies + "/all", {
      params: payload,
    });
    if (response.status === 200) {
      commit("SET_ALL_TAXONOMIES", response.data.data);
    }
    return response;
  },

  async create({ commit }, payload) {
    const response = await axios.post(urlTaxonomies, payload);
    if (response.status === 200) {
      commit("CREATE_TAXONOMIES");
    }
    return response;
  },

  async update({ commit }, { id, payload }) {
    const response = await axios.put(urlTaxonomies + "/" + id, payload);
    if (response.status === 200) {
      commit("UPDATE_TAXONOMIES");
    }
    return response;
  },

  async deleteItemList({ commit }, id) {
    commit("DELETE_TAXONOMIES_ITEM_LIST", id);
  },

  // eslint-disable-next-line no-unused-vars
  async changeOrder({ commit }, payload) {
    const response = await axios.post(urlTaxonomies + "/change-order", payload);
    return response;
  },
};

const mutations = {
  SET_TAXONOMIES(state, data) {
    state.list = data;
  },

  SET_ALL_TAXONOMIES(state, data) {
    state.allTaxonomies = data;
  },

  CREATE_TAXONOMIES() {},

  UPDATE_TAXONOMIES() {},

  DELETE_TAXONOMIES_ITEM_LIST(state, id) {
    const index = state.list.findIndex((u) => u.id === id);

    if (index >= 0) {
      state.list.splice(index, 1);
    }
  },

  SET_MENU_FILTER_LIBRARYDICTIONARY(state, data) {
    state.menuFIlterLibraryDictionary = data;
  },

  SET_MENU_FILTER_BLOCK(state, data) {
    state.menuFIlterBlock = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
